const Routes = {
	admin: {
		namespace: '/admin',
		home: {
			dashboardRoute: {
				name: 'admin-dashboard-route',
				path: 'dashboard'
			}
		},
		user: {
			createRoute: {
				name: 'admin-user-create-route',
				path: 'users/new'
			},
			indexRoute: {
				name: 'admin-user-index-route',
				path: 'users'
			},
			editRoute: {
				name: 'admin-user-edit-route',
				path: 'users/:id/edit'
			}
		},
		sortition: {
			createRoute: {
				name: 'admin-sortition-create-route',
				path: 'sortitions/new'
			},
			editRoute: {
				name: 'admin-sortition-edit-route',
				path: 'sortitions/:id/edit'
			},
			indexRoute: {
				name: 'admin-sortition-index-route',
				path: 'sortitions'
			}
		},
		resultApiUser: {
			createRoute: {
				name: 'admin-result-api-user-create-route',
				path: 'result-api-users/new'
			},
			editRoute: {
				name: 'admin-result-api-user-edit-route',
				path: 'result-api-users/:id/edit'
			},
			indexRoute: {
				name: 'admin-result-api-user-index-route',
				path: 'result-api-users'
			}
		},
		sortitionDisplay: {
			createRoute: {
				name: 'admin-sortition-display-create-route',
				path: 'sortition-displays/new'
			},
			editRoute: {
				name: 'admin-sortition-display-edit-route',
				path: 'sortition-displays/:id/edit'
			},
			indexRoute: {
				name: 'admin-sortition-display-index-route',
				path: 'sortition-displays'
			}
		},
		lottery: {
			createRoute: {
				name: 'admin-lottery-create-route',
				path: 'lotteries/new'
			},
			editRoute: {
				name: 'admin-lottery-edit-route',
				path: 'lotteries/:id/edit'
			},
			indexRoute: {
				name: 'admin-lottery-index-route',
				path: 'lotteries'
			}
		},
		profit: {
			indexRoute: {
				name: 'profits-route',
				path: 'profit'
			}
		},
		result: {
			indexRoute: {
				name: 'admin-result-index-route',
				path: 'results'
			}
		},
		prize: {
			editRoute: {
				name: 'admin-prize-edit-route',
				path: 'prize/edit'
			}
		},
		server: {
			createRoute: {
				name: 'admin-server-create-route',
				path: 'servers/new'
			},
			indexRoute: {
				name: 'admin-server-index-route',
				path: 'servers'
			}
		},
		actionLog: {
			indexRoute: {
				name: 'admin-action-log-route',
				path: 'action-log'
			}
		}
	},
	session: {
		createRoute: {
			name: 'session-create-route',
			path: '/sign_in'
		}
	},
	others: {
		notFoundRoute: {
			name: 'not-found-route',
			path: '/404'
		}
	}
};

export default Routes;
